export default [
	{
		path: "students",
		component: () => import("../pages/index.vue"),
		children: [
			{
				path: "",
				name: "teacherStudents",
				component: () => import("../pages/list.vue"),
			},
			{
				path: ":studentId",
				name: "teacherStudentsProfile",
				component: () => import("../pages/_studentId.vue"),
			},
		],
	},
];
